import { render } from "./LeftMenu.vue?vue&type=template&id=07f846e0&scoped=true"
import script from "./LeftMenu.vue?vue&type=script&lang=js"
export * from "./LeftMenu.vue?vue&type=script&lang=js"

import "./LeftMenu.vue?vue&type=style&index=0&id=07f846e0&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/fbdnextui_staging-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07f846e0"]])

export default __exports__